const PUBLIC_ROUTES = {
  LOGIN: '/login',
  RECOVER_PASSWORD: '/recover-password',
};

export const PRIVATE_ROUTES = {
  HOME: '/home',
  PROFILE: '/profile',
  PATIENTS: '/patients',
  PATIENT_APPOINTMENT: '/patients/:id/appointment',
  PATIENT_PROFILE: '/patients/:id/profile',
  APPOINTMENTS: '/appointments',
  APPOINTMENTS_RESERVE: '/appointments/reserve',
  APPOINTMENTS_SUCCESS: '/appointments/success',
  BILLING: '/billing',
  DOCS: '/docs',
  ADMINISTRATORS: '/administrators',
  METRICS: '/metrics',
  CHAT: '/chat',
};

export const ROUTES = {
  ROOT: '/',
  ...PUBLIC_ROUTES,
  ...PRIVATE_ROUTES,
};
